import React from 'react';

type Props = {
  className?: string;
};

const ChevronDownIcon = ({ className }: Props) => (
  <svg
    width="16"
    height="10"
    viewBox="0 0 16 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M1 1.66669L8 8.66669L15 1.66669"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export { ChevronDownIcon };
